import { useMemo } from "react";
import { sortByCustom } from "@repo/utils";
import type { TabWindow, TabWindowState } from "../../task.types";

type Props<T> = {
  windows: TabWindow<T>[];
};

export const useWindowState = <T>({ windows }: Props<T>) => {
  const sortedWindows = useMemo(() => {
    return sortByCustom(windows, (window) => window?.state?.order ?? 0, "asc");
  }, [windows]);

  const activeWindows = useMemo(() => {
    return windows.filter((w) => !w?.state?.isMinimized);
  }, [windows]);

  const minimizedWindows = useMemo(() => {
    return windows
      .filter((w) => w?.state?.isMinimized)
      .map((w) => w.state)
      .filter((state): state is TabWindowState => state !== undefined);
  }, [windows]);

  return useMemo(
    () => ({ sortedWindows, activeWindows, minimizedWindows }),
    [sortedWindows, activeWindows, minimizedWindows]
  );
};
